import React, { useState } from "react";
import DataTableServerSidePagination from "../components/dataTableServerSidepagination/DataTableServerSidePagination.tsx";
import "./Delivery.css";
import pendingDot from "./../../assets/icons/pendingdot.png";
import approvegDot from "./../../assets/icons/arrival.png";
import rejectDot from "./../../assets/icons/cancelDot.png";
import readyDot from "./../../assets/icons/readyDot.png";
import deliveredDot from "./../../assets/icons/completed.png";
import totalPendingIcon from "./../../assets/icons/file.png";
import dollar from "./../../assets/icons/coin.png";
import burger from "../../assets/icons/burger1.png";
import totalDelivered from "./../../assets/icons/totalDelivered.png";
import ongoing from "../../assets/icons/ongoin.png";
import TopHeader from "../../components/TopHeader.tsx";

function Courier() {
  const [akgisLoading, SetakgIsLoading] = useState(false);
  const [akgrows, setAkgrows] = useState<
    {
      id: number;
      image: string;
      address: string;
      item: string;
      orderId: string;
      quantity: string;
      status: string;
    }[]
  >([]);

  const [akgpageState, setakgpageState] = React.useState({
    isLoading: false,

    total: 0,
    page: 1,
    pageSize: 10,
  });

  const Cancelationtcolumns = [
    {
      field: "image",
      headerName: "Restaurant",
      flex: 1,
      renderCell: (params) => (
        <div className="d-flex gap-2">
          <img
            // src={params.row.image}
            src={burger}
            style={{ width: "2rem", height: "2rem" }}
            alt={params.row.image}
          />
          <span>{params.row.item}</span>
        </div>
      ),
    },
    { field: "address", headerName: "DeliveryAddress", flex: 1 },

    { field: "orderId", headerName: "OrderId", flex: 1 },

    { field: "quantity", headerName: "Quantity", flex: 1 },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => {
        const status = params.row.status;

        let statusStyle = {};
        let statusText = "";

        switch (status) {
          case "Pending":
            statusStyle = { backgroundColor: "#FCC117" };
            statusText = "Pick Up";
            break;
          case "Arrived":
            statusStyle = { backgroundColor: "#4CAF50" };
            statusText = "Arrived";
            break;
          case "Delivered":
            statusStyle = { backgroundColor: "#3498DB" };
            statusText = "Delivered";
            break;
          case "Completed":
            statusStyle = { backgroundColor: "#27AE60" };
            statusText = "Completed";
            break;
          case "Canceled":
            statusStyle = { backgroundColor: "#E74C3C" };
            statusText = "Canceled";
            break;
          default:
            break;
        }

        return (
          <div className="d-flex statusBackground" style={statusStyle}>
            <p>{statusText}</p>
          </div>
        );
      },
    },

    // {
    //   field: 'status',
    //   headerName: 'Status',
    //   flex: 1,
    //   renderCell: (params) => (
    //     <div className='d-flex statusBackground'>
    //       <div style={{ padding: '0.1rem 0rem 0.1rem 0.5rem' }}>
    //         <img src={pendingDot} style={{ width: '1rem', height: '1rem' }} />
    //       </div>
    //       <p>Pending</p>
    //     </div>
    //   ),
    // },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: (params) => (
        <div className="d-flex ">
          <div className="actionBackground">
            <p>View</p>
          </div>
        </div>
      ),
      align: "center",
      headerAlign: "center",
    },
  ];

  const cancellationRows = [
    {
      id: 1,
      image:
        "https://gotastelivestorage.blob.core.windows.net/gotasteimages/1acf33e7-329a-4adf-b209-82e645839a7d",
      address: "Gulshan",
      item: "Burger King",
      orderId: "SO001",
      quantity: "5",
    },
    {
      id: 2,
      image:
        "https://gotastelivestorage.blob.core.windows.net/gotasteimages/5e3655c3-1a50-427f-94b4-afd040875bc3",
      address: "Khulsi",
      item: "PizzaBurg",
      orderId: "SO002",
      quantity: "6",
    },
    {
      id: 3,
      image:
        "https://gotastelivestorage.blob.core.windows.net/gotasteimages/3f231bba-d6d5-4200-aa26-65335996fde3",
      address: "Nasirabad",
      item: "Barcode",
      orderId: "SO003",
      quantity: "4",
    },
  ];

  // const salesOrderListPage = async (props, from) => {};

  // const GetPurchaseOrderNoAPi = async (props) => {
  //   await salesOrderListPage(props, 'Main');
  // };

  const fakeData = {
    pageState: {
      total: 3,
    },
    rows: [
      {
        id: 1,
        image: "path/to/image1.jpg",
        address: "Gulshan",
        item: "Burger King",
        orderId: "SO001",
        quantity: "5",
        status: "Delivered",
      },
      {
        id: 2,
        image: "path/to/image2.jpg",
        address: "Khulsi",
        item: "PizzaBurg",
        orderId: "SO002",
        quantity: "6",
        status: "Pending",
      },
      {
        id: 3,
        image: "path/to/image3.jpg",
        address: "Nasirabad",
        item: "Barcode",
        orderId: "SO003",
        quantity: "4",
        status: "Completed",
      },
      {
        id: 4,
        image: "path/to/image3.jpg",
        address: "Dhanmondi",
        item: "Barcode",
        orderId: "SO004",
        quantity: "10",
        status: "Canceled",
      },
      {
        id: 5,
        image: "path/to/image3.jpg",
        address: "Nasirabad",
        item: "Banani",
        orderId: "SO005",
        quantity: "3",
        status: "Arrived",
      },
    ],
  };

  const GetPurchaseOrderNoAPi = async () => {
    // Use fake data directly
    try {
      SetakgIsLoading(true);

      // Simulate an API call delay (remove this in a real API call)
      await new Promise((resolve) => setTimeout(resolve, 1000));

      setAkgrows(fakeData.rows);
      setakgpageState({
        isLoading: false,
        total: fakeData.pageState.total,
        page: 1,
        pageSize: 10,
      });
    } catch (error) {
      console.error("Error in GetPurchaseOrderNoAPi:", error);
    } finally {
      SetakgIsLoading(false);
    }
  };
  //sales order table end

  return (
    <>
      <TopHeader />
      <div className="d-flex justify-content-center">
        <div className="gap-3 m-2 mb-3 counterDiv">
          <div className="d-flex gap-2 align-items-center p-4">
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "50%",
                height: "3rem",
                width: "3rem",
              }}
            >
              <img
                src={totalPendingIcon}
                style={{ width: "3rem", height: "3rem", padding: "10px" }}
                alt={totalPendingIcon}
              />
            </div>
            <div>
              <p>50</p>
              <span>Total pendings</span>
            </div>
            <div className="vl"></div>
          </div>
          <div className="d-flex gap-2 align-items-center p-4">
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "50%",
                height: "3rem",
                width: "3rem",
              }}
            >
              <img
                src={ongoing}
                style={{ width: "3rem", height: "3rem", padding: "10px" }}
                alt={ongoing}
              />
            </div>
            <div>
              <p>10</p>
              <span>Total ongoing</span>
            </div>
            <div className="vl"></div>
          </div>
          <div className="d-flex gap-2 align-items-center p-4">
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "50%",
                height: "3rem",
                width: "3rem",
              }}
            >
              <img
                src={totalDelivered}
                style={{ width: "3rem", height: "3rem", padding: "10px" }}
                alt={totalDelivered}
              />
            </div>
            <div>
              <p>70</p>
              <span>Total delivered</span>
            </div>
            <div className="vl"></div>
          </div>
          <div className="d-flex gap-2 align-items-center p-4">
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "50%",
                height: "3rem",
                width: "3rem",
              }}
            >
              <img
                src={dollar}
                style={{ width: "3rem", height: "3rem", padding: "10px" }}
                alt={dollar}
              />
            </div>
            {/* <div>
              <p>50000</p>
              <span>Total revenue</span>
            </div> */}
          </div>
        </div>
      </div>
      {/* starting status section */}
      <div className="d-flex gap-1 m-2 justify-content-center align-items-center">
        <div className="d-flex gap-1">
          <div
            className="statusButton"
            style={{ backgroundColor: "rgba(249, 197, 138, 0.302)" }}
          >
            <div className="statusButtonElement gap-1">
              <div style={{ alignItems: "center" }}>
                <img
                  src={pendingDot}
                  style={{ width: "0.8rem", height: "0.8rem" }}
                  alt={pendingDot}
                />
              </div>

              <p style={{ color: "rgb(211, 146, 17)" }}>Pick Up</p>
            </div>
          </div>

          <div
            className=" statusButton"
            style={{ backgroundColor: "rgba(164, 208, 111, 0.364)" }}
          >
            <div className="statusButtonElement gap-1">
              <div>
                <img
                  src={approvegDot}
                  style={{ width: "1rem", height: "1rem" }}
                  alt={approvegDot}
                />
              </div>
              <p style={{ color: "rgb(37, 151, 65)" }}>
                Arrived at destination
              </p>
            </div>
          </div>

          <div
            className="statusButton"
            style={{ backgroundColor: "rgba(157, 220, 243, 0.266)" }}
          >
            <div className="statusButtonElement gap-1">
              <div>
                <img src={readyDot} style={{ width: "1rem", height: "1rem" }} />
              </div>
              <p style={{ color: "#166CBF" }}>Delivered</p>
            </div>
          </div>
          <div
            className="statusButton"
            style={{ backgroundColor: "rgba(164, 208, 111, 0.364)" }}
          >
            <div className="statusButtonElement gap-1">
              <div>
                <img
                  src={deliveredDot}
                  style={{ width: "1rem", height: "1rem" }}
                  alt={deliveredDot}
                />
              </div>
              <p style={{ color: "#40760E" }}>Completed</p>
            </div>
          </div>
          <div
            className="statusButton"
            style={{ backgroundColor: "rgba(243, 138, 128, 0.266)" }}
          >
            <div className="statusButtonElement gap-1">
              <div>
                <img
                  src={rejectDot}
                  style={{ width: "0.8rem", height: "0.8rem" }}
                  alt={rejectDot}
                />
              </div>
              <p style={{ color: "#E30000" }}>Cancel</p>
            </div>
          </div>
        </div>
        <div className="pill-search-field">
          <input
            type="text"
            placeholder="Search..."
            // value={searchTerm}
            // onChange={handleSearch}
          />
        </div>
      </div>
      {/* Ending status section */}
      {/* <DataTableServerSidePagination
        pageState={akgpageState}
        GetPurchaseOrderNoAPi={GetPurchaseOrderNoAPi}
        isLoading={akgisLoading}
        rows={cancellationRows}
        columns={Cancelationtcolumns}
      /> */}
      <DataTableServerSidePagination
        pageState={akgpageState}
        GetDataFromAPi={GetPurchaseOrderNoAPi}
        isLoading={akgisLoading}
        rows={akgrows}
        columns={Cancelationtcolumns}
      />
    </>
  );
}

export default Courier;
